import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import EnableDialogComponent from './EnableDialog';
import { setV2 } from '../../../../store/actions/pagesV2';
import { selectDeselectAll, setEnableDialog } from '../../../../store/actions/shoppables';
import { getPaginationFilter } from '../../../../util/pagination';

export const EnableDialog = connect(
    () => {
        const selectClaimIds = (state, props) => state.pagesV2['shoppable-landing'].selected;
        const selectEnableDialog = (state) => state.shoppables.enableDialog;

        const selectOpen = createSelector(
            selectEnableDialog,
            (enableDialog) => {
                if (enableDialog && enableDialog?.open) {
                    return true
                }
                return false
            }
        );

        const selectEnabledClick = createSelector(
            selectEnableDialog,
            (enableDialog) => {
                if (enableDialog && enableDialog?.isEnableClicked) {
                    return true
                }
                return false
            }
        )

        const selectCustomFilter = createSelector(
            (state) => state.pages['shoppable-landing'],
            (table: any) => {
                return table.customFilter;
            }
        );
        
        const selectFilter = createSelector(
            (state) => state.pages['shoppable-landing'],
            (state, props) => props.fields,
            (table: any, fields) => {
                return getPaginationFilter(table.filter, null, null, table.customFilter);
            }
        );
        
        const selectSort = createSelector(
            (state) => state.pages['shoppable-landing'],
            (table: any) => {
                if (table.sort.length === 0) {
                    return [];
                }
                return table.sort;
            },
        );
        
        const selectPage = createSelector(
            (state) => state.pages['shoppable-landing'],
            (table: any) => {
                return table.page;
            },
        );

        return (state, props) => ({
            open: selectOpen(state),
            isEnableClicked: selectEnabledClick(state),
            selectedItems: selectClaimIds(state, props),
            selectAllStatusPending: state.shoppables.all.pending,
            filter: selectFilter(state, props),
            sort: selectSort(state),
            page: selectPage(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            setSelected: (value) => setV2('shoppable-landing', 'selected', value),
            setEnableDialog: setEnableDialog,
            selectDeselectAll: selectDeselectAll
        }, dispatch)
    })
)(injectIntl(EnableDialogComponent));